import {
  BookingStatus,
  enumBookingStatus,
} from '@rematter/frontend-lib-api-client';
import { Badge } from '@rematter/ui-web';

export type BookingStatusBadgeProps = { status: BookingStatus };

export const BookingStatusBadge = ({ status }: BookingStatusBadgeProps) => (
  <Badge
    className="@BookingStatusBadge"
    color={status === enumBookingStatus.Open ? 'primary' : 'success'}
  >
    {status}
  </Badge>
);

export type BookingPurchaseOrderBadgeProps = { purchaseOrderNumber?: string };

export const BookingPurchaseOrderBadge = ({
  purchaseOrderNumber,
}: BookingPurchaseOrderBadgeProps) => (
  <Badge color={'primary'} className="@BookingPurchaseOrderBadge">
    PO #{purchaseOrderNumber}
  </Badge>
);
